import { contactCustomerSupport } from '@goldcast/api/backend';
import AlertDialog from './AlertDialog';
import { showSuccessToast, showErrorToast } from '@/libs/toast/toast';
import { currentUser } from '@/stores/user';
import { RestrictionType } from '@/hooks/useFeatureRestriction';

type ContactSalesDialogProps = {
  isOpen: boolean;
  restrictionType: RestrictionType;
  heading: string;
  message: string;
  primaryActionTitle?: string;
  secondaryActionTitle?: string;
  handleSecondaryActionClick?: () => void;
  handlePrimaryActionClick?: () => void;
};

const restrictionText: Record<RestrictionType, string> = {
  captionTranslation: 'You are not allowed to translate captions for this clip.',
  multiLanguageSupport: 'You are not allowed to use multi-language features for this clip.'
};

const ContactSalesDialog = ({
  isOpen,
  restrictionType,
  heading,
  message,
  primaryActionTitle = 'OK',
  secondaryActionTitle = 'Contact Sales',
  handleSecondaryActionClick = () => {},
  handlePrimaryActionClick = () => {}
}: ContactSalesDialogProps) => {
  const handleContactSales = () => {
    contactCustomerSupport({
      id: currentUser.getSnapshot()?.organization as string,
      body: {
        text: restrictionText[restrictionType]
      }
    })
      .then(() => {
        handleSecondaryActionClick();
        showSuccessToast('We have received your request. Our team will get in touch with you soon.');
      })
      .catch(error => {
        showErrorToast(JSON.parse(error)[0]?.message || 'An error occurred!');
      });
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      type="lock"
      heading={heading}
      message={message}
      primaryActionTitle={primaryActionTitle}
      handlePrimaryActionClick={handlePrimaryActionClick}
      secondaryActionTitle={secondaryActionTitle}
      handleSecondaryActionClick={handleContactSales}
    />
  );
};

export default ContactSalesDialog;
